import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageComponent } from '../../components/page/page.component';
import {  FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FieldContainerDirective } from 'src/app/general/directives/field/field-container.directive';
import { FieldDirective } from 'src/app/general/directives/field/field.directive';
import { FormService } from 'src/app/general/services/form.service';
import { SessionService } from '../../services/session.service';
import { ActionComponent } from 'src/app/general/components/action/action.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TitleComponent } from 'src/app/general/components/title/title.component';
import { OrdersModel } from '../../components/orders/orders-model';
import { BackendService } from '../../services/backend.service';
import { OrdersComponent } from '../../components/orders/orders.component';
import { AuthenticationStatus } from '../../util/util';
import { RouteUtil } from 'src/app/general/util/route-util';
import { Util } from 'src/app/general/util/util';
import { ActivatedRoute } from '@angular/router';
import { DeviceHeaderComponent } from '../../components/device-header/device-header.component';
import { PaidOrdersByPhoneModel } from '../../components/orders/paid-orders-by-phone-model';

@Component({
  selector: 'app-paid-orders-by-phone-page',
  standalone: true,
  imports: [
    CommonModule,
    PageComponent,
    TitleComponent,
    TranslateModule,
    FieldContainerDirective,
    FieldDirective,
    ActionComponent,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    OrdersComponent,
    DeviceHeaderComponent,
    TitleComponent
  ],
  templateUrl: './paid-orders-by-phone-page.component.html',
  styleUrls: ['./paid-orders-by-phone-page.component.css']
})
export class PaidOrdersByPhonePageComponent implements OnInit {

  phoneNumber: string;

  ordersModel: OrdersModel;

  constructor(
      public formService: FormService,
      public sessionService: SessionService,
      private backendService: BackendService,
      private activatedRoute: ActivatedRoute) {
    this.phoneNumber = '';
    this.ordersModel = new PaidOrdersByPhoneModel('', this.backendService);
  }

  ngOnInit(): void {
    if (this.sessionService.enforceAuthentication()
        == AuthenticationStatus.USER_NOT_AUTHENTICATED_AND_REDIRECTED_TO_SIGNIN_PAGE) {
      return;
    }

    const pathParams = RouteUtil.getPathParams(this.activatedRoute);
    this.phoneNumber = Util.safeString(pathParams.get('phone'));
    this.ordersModel = new PaidOrdersByPhoneModel(this.phoneNumber, this.backendService);
  }
}
